export type AvailabilitySignal = "High" | "Medium" | "Low";

export const AVAILABILITY_QUESTION_CODES = ["A6", "A7", "A8", "A9", "A10", "A11"] as const;
export const AVAILABILITY_MAX_RAW_SCORE = 30;
export const AVAILABILITY_HIGH_PERCENT = 80;
export const AVAILABILITY_MEDIUM_PERCENT = 40;

export function availabilityPercentFromRaw(rawScore: number) {
  if (!Number.isFinite(rawScore)) return 0;

  return Math.min(100, Math.max(0, (rawScore / AVAILABILITY_MAX_RAW_SCORE) * 100));
}

export function classifyAvailabilityPercent(percent: number): AvailabilitySignal {
  if (percent >= AVAILABILITY_HIGH_PERCENT) return "High";
  if (percent >= AVAILABILITY_MEDIUM_PERCENT) return "Medium";
  return "Low";
}

export function classifyAvailabilityRaw(rawScore: number): AvailabilitySignal {
  return classifyAvailabilityPercent(availabilityPercentFromRaw(rawScore));
}

export function representativeAvailabilityPercent(signal: AvailabilitySignal) {
  if (signal === "High") return AVAILABILITY_HIGH_PERCENT;
  if (signal === "Medium") return AVAILABILITY_MEDIUM_PERCENT;
  return 0;
}
